import { memo } from "react";
import type { Measurement } from "types";
import { useTranslation } from "react-i18next";
import useBoolean from "hooks/useBoolean";
import Button from "components/Button";
import EditIcon from "components/Icons/EditIcon";
import EditMeasurementDialog from "./EditMeasurementDialog";

interface EditMeasurementActionProps {
  measurement: Measurement;
}

function EditMeasurementAction(props: EditMeasurementActionProps) {
  const { measurement } = props;
  const { t } = useTranslation();
  const { value: open, toggle } = useBoolean();

  return (
    <>
      <Button size="small" variant="primary" startIcon={<EditIcon />} onClick={toggle}>
        {t("global.edit_text")}
      </Button>
      <EditMeasurementDialog measurement={measurement} open={open} onClose={toggle} />
    </>
  );
}

export default memo(EditMeasurementAction);
